module.exports = __webpack_public_path__ + "static/media/Download.bcbd6b0f.svg";